$(document).ready(function () {
    $('debug-btn').on('click', function () {
        document.body.classList.toggle("debug-components");
    });
});

